__turbopack_context__.v({
  "className": "noto_sans_sc_fdb66a5e-module__maMrgG__className",
});
